import { render, staticRenderFns } from "./activity-register.vue?vue&type=template&id=4be1d3d0&scoped=true&"
import script from "./activity-register.vue?vue&type=script&lang=js&"
export * from "./activity-register.vue?vue&type=script&lang=js&"
import style0 from "./activity-register.vue?vue&type=style&index=0&id=4be1d3d0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4be1d3d0",
  null
  
)

export default component.exports